module.exports = __webpack_public_path__ + "static/media/Full_Modal_Header.111e9d2d.png";